export default __webpack_public_path__ + "static/media/calendar.bc7a2e1f.svg";